<template>
  <div class="flex w-[154px] h-9 space-x-2 py-1 px-1 text-[14px] bg-[#F2F4F7] rounded-[6px] border border-[#F2F4F7]">
    <p 
      v-for="status in statusOptions" 
      :key="status" 
      :class="[
        'flex items-center cursor-pointer rounded-[6px] px-2 py-1',
        selectedStatus === status ? 'bg-[#FFFFFF] text-[344054] font-bold' : 'bg-[#F2F4F7] text-grayDark'
      ]"
      @click="selectStatus(status)"
    >
      {{ status }}
    </p>
  </div>
</template>


<script>
export default {
  data() {
    return {
      selectedStatus: 'Details', // Default value
      statusOptions: ['Details', 'Activity'],
    };
  },
  methods: {
    selectStatus(status) {
      this.selectedStatus = status;
      this.$emit('status-changed', status); // Emit event to parent component
    },
  },
};
</script>


